module.exports = __webpack_public_path__ + "img/fileupload.fe0d90ac.svg";